<template>

	<div class="row">

		<div class="col-md-2" v-if="agenda.creationUser">

			<popover placement="right" width="350" trigger="hover">

				<button type="button" class="btn btn-circle grey-salsa btn-outline btn-sm" slot="reference">
					<i class="fa fa-flag" aria-hidden="true"></i>
					<span v-translate>Criada por...</span>
				</button>

				<ul class="list-group m-b-0">
					<li class="list-group-item">
						<strong>{{ agenda.creationUser.name }}</strong>
						<span v-translate>no dia</span>
						<br>
						<span class="text-muted">em {{ agenda.creationDateTime | date('DD/MM/YYYY HH:mm:ss')}}</span>
					</li>
				</ul>

			</popover>

		</div>

		<div class="col-md-2" v-if="agenda.updateUserLog">

			<popover placement="right" width="350" trigger="hover">

				<button type="button" class="btn btn-circle grey-salsa btn-outline btn-sm" slot="reference">
					<i class="fa fa-pencil" aria-hidden="true"></i>
					<span v-translate>Editada por...</span>
				</button>

				<ul class="list-group m-b-0">
					<li class="list-group-item" v-for="log in agenda.updateUserLog" v-if="log.schoolUser && log.dateTime">
						{{ log.schoolUser.name }}
						<br>
						<span class="text-muted">em {{ log.dateTime | date('DD/MM/YYYY HH:mm:ss') }}</span>
					</li>
				</ul>

			</popover>

		</div>

		<div class="col-md-2" v-if="agenda.publishedUser">

			<popover placement="right" width="350" trigger="hover">

				<button type="button" class="btn btn-circle grey-salsa btn-outline btn-sm" slot="reference">
					<i class="fa fa-paper-plane" aria-hidden="true"></i>
					<span v-translate>Publicada por...</span>
				</button>

				<ul class="list-group m-b-0">
					<li class="list-group-item">
						<strong>{{ agenda.publishedUser.name }}</strong>
						<span v-translate>no dia</span>
						<br>
						<span class="text-muted">em {{ agenda.publishedDateTime | date('DD/MM/YYYY HH:mm') }}</span>
					</li>
				</ul>

			</popover>

		</div>

	</div>

</template>

<script>

	import AgendaEditors from './';
	export default AgendaEditors;

</script>



// WEBPACK FOOTER //
// agenda-editors.vue?7e829c72